var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonAngleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.48679 9.80834C1.3657 9.93236 1.21159 10 1.02997 10C0.666707 10 0.375 9.70688 0.375 9.33484C0.375 9.14882 0.452055 8.97971 0.578645 8.85006L4.43138 4.99436L0.578645 1.14994C0.452055 1.02029 0.375 0.845547 0.375 0.665163C0.375 0.293123 0.666707 0 1.02997 0C1.21159 0 1.3657 0.0676437 1.48679 0.191657L5.76884 4.47576C5.92295 4.62232 5.9945 4.80271 6 5C6 5.19729 5.92295 5.3664 5.76884 5.5186L1.48679 9.80834Z",
    fill: "#1D1E2C",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonAngleRight);
export default __webpack_public_path__ + "static/media/button-angle-right.bfd2b1515bbccf377d80d96de4469c38.svg";
export { ForwardRef as ReactComponent };